import { useAppConfig } from "@/queries/settings/use-app.query.ts";
import { ApiAppConfigUIEmployeeProfileTable } from "@/types/config.types.ts";
import { ApiCFTabType, ApiFieldTypes, ApiTableTypes } from "@/types/custom-field.types.ts";
import { useCallback, useMemo } from "react";

export const useSystemTableConfig = (
  tableType: ApiTableTypes,
  profileMode: "edit" | "view" = "edit"
) => {
  const { data: config, ...queryState } = useAppConfig();

  const table = useMemo<ApiAppConfigUIEmployeeProfileTable | undefined>(() => {
    const profileConfig =
      profileMode === "edit" ? config?.ui.employee_profile_edit : config?.ui.employee_profile;
    const workInfoTab = profileConfig?.tabs.find(({ tab }) => tab.type === ApiCFTabType.work_info);

    return (
      workInfoTab?.items.find((item) => item.table?.table_type === tableType)?.table ?? undefined
    );
  }, [config, profileMode, tableType]);

  const fields = useMemo(
    () => [...(table?.table_fields ?? [])].sort((left, right) => left.sort - right.sort),
    [table]
  );
  const systemFields = useMemo(
    () => fields.filter((field) => field.type !== ApiFieldTypes.custom),
    [fields]
  );
  const customFields = useMemo(
    () => fields.filter((field) => field.type === ApiFieldTypes.custom),
    [fields]
  );
  const isMandatory = useCallback(
    (type: ApiFieldTypes) =>
      systemFields.find((field) => field.type === type)?.is_mandatory ?? false,
    [systemFields]
  );

  return { table, fields, systemFields, customFields, isMandatory, ...queryState };
};
